import React from 'react';
import InputForm from './InputForm';

// Colores por defecto: son EXACTAMENTE los que ya se ven hoy en las cards
// (fondo blanco de la card, texto gray-600 de Tailwind) - así, mientras el
// usuario no toque nada, el widget se ve igual que siempre.
export const DEFAULT_HEADER_COLOR = '#ffffff';
export const DEFAULT_HEADER_TEXT_COLOR = '#4b5563';

// Campo reutilizable para el color de fondo y de texto del header (la
// barra donde va el título) de cualquier widget. `onChange(field, value)`
// sigue la misma firma que ya usan los handlers de estilo existentes
// (handleStyleChange, o un setConf inline) - cada Form solo tiene que
// pasarle su propio setter. `compact` en InputForm cambia su mb-5 por un
// mb-2 uniforme, así el gap-2 del contenedor manda la separación real.
const WidgetHeaderStyleFields = ({ headerColor, headerTextColor, onChange }) => {
  return (
    <div className='flex flex-col gap-2'>
      <span className='text-sm font-medium text-gray-500 mt-1'>Encabezado</span>
      <InputForm
        type="color"
        id="headerColor"
        text="Color del encabezado"
        value={headerColor || DEFAULT_HEADER_COLOR}
        onChange={(val) => onChange('headerColor', val)}
        compact
      />
      <InputForm
        type="color"
        id="headerTextColor"
        text="Color del texto del encabezado"
        value={headerTextColor || DEFAULT_HEADER_TEXT_COLOR}
        onChange={(val) => onChange('headerTextColor', val)}
        compact
      />
    </div>
  );
};

export default WidgetHeaderStyleFields;
